import { useState } from "react";
import { Loader2, Save } from "lucide-react";

export default function BFMissingCodes({ products, brands, setProduct, save, busy }) {
  const [open, setOpen] = useState(false);
  const missing = products.filter((p) => p.active && !(p.code || "").trim() && !(p.shades || []).some((s) => (s.code || "").trim()));
  const [ids] = useState(() => new Set(missing.map((p) => p.id)));
  const rows = products.filter((p) => ids.has(p.id));
  const bname = Object.fromEntries((brands || []).map((b) => [b.id, b.name]));
  return (
    <section className={`invite-box ${missing.length ? "bf-codes-warn" : ""}`} data-testid="bfa-missing-codes">
      <h3>Produse fără cod <span className={missing.length ? "bf-red-tag" : "bfa-pf-tag"} data-testid="bf-codes-count">{missing.length}</span></h3>
      <p className="st-hint">{missing.length ? "Aceste produse active apar pe proforme cu „-” la cod. Completează codul și apasă Salvează." : "Toate produsele active au cod."}</p>
      {rows.length > 0 && <button type="button" className="st-btn st-btn--light" onClick={() => setOpen(!open)} data-testid="bf-codes-toggle">{open ? "Ascunde lista" : "Completează codurile"}</button>}
      {open && (
        <>
          <ul className="bf-codes" data-testid="bf-codes-list">
            {rows.map((p) => (
              <li key={p.id} className={(p.code || "").trim() ? "is-ok" : ""} data-testid={`bf-code-row-${p.id}`}>
                <span><b>{p.name}</b><small>{bname[p.brand] || p.brand}</small></span>
                <input value={p.code || ""} placeholder="Cod produs" maxLength={40} onChange={(e) => setProduct({ ...p, code: e.target.value })} data-testid={`bf-code-input-${p.id}`} />
              </li>
            ))}
          </ul>
          <button type="button" className="st-btn st-btn--silver" onClick={save} disabled={busy} data-testid="bf-codes-save">
            {busy ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} Salvează codurile
          </button>
        </>
      )}
    </section>
  );
}
